import { Chip, colors, Grid, Tooltip, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import { formatCurrency } from "helpers/utils";

interface Props {
  categoria: String;
  valor: number;
  inscritos: number;
}

export default function CardRecCatIdade({
  categoria,
  valor,
  inscritos,
}: Props) {
  return (
    <MDBox
      color="white"
      bgColor="#044BA0"
      borderRadius="sm"
      shadow="lg"
      p={2}
      width={150}
      height={136}
    >
      <Tooltip title={categoria} placement="bottom">
        <Typography
          variant="subtitle2"
          color={colors.grey[50]}
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
          }}
        >
          {categoria}
        </Typography>
      </Tooltip>

      <Tooltip title={`${formatCurrency(valor)}`} placement="bottom">
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          py={1}
          color={colors.grey[50]}
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
          }}
        >
          {formatCurrency(valor)}
        </Typography>
      </Tooltip>
      <MDBox display="flex" justifyContent="flex-end">
        <Tooltip title={`Atletas na categoria ${categoria}`} placement="bottom">
          <Chip label={inscritos} variant="filled" color="secondary" />
        </Tooltip>
      </MDBox>
    </MDBox>
  );
}
